import React, { useEffect, useState } from 'react';
import { H5 } from '../../../../AbstractElements';
import { FormGroup, Input, Label, FormFeedback, Button } from 'reactstrap';

export const callFormStateMappings = {
    'Taslak': 'Çağrı Merkezi',
    'Yeni Çağrı Formu': 'Çağrı Merkezi',
    'Eksper Onay Bekleniyor': 'Eksper',
    'Yönetici Onay Bekleniyor': 'Yönetici',
    'Ödeme Bekleniyor': 'Muhasebe',
    'Vekalet Bekleniyor': 'Vekalet Departmanı',
    'Evrak Bekleniyor': 'Evrak İşlemleri',
    'Eksper İşlem Bekleniyor': 'Eksper',
    'Yeni Eksper İşlem Bekleniyor': 'Yeni Eksper',
    'Eksper Rapor Bekleniyor': 'Eksper Rapor',
    'Yeni Eksper Rapor Bekleniyor': 'Yeni Eksper Rapor',
    'Eksper Raporu Ödeme Bekleniyor': 'Eksper Raporu Ödeme',
    'Yeni Eksper Raporu Ödeme Bekleniyor': 'Yeni Eksper Raporu Ödeme',
    'Sigorta Başvuru Dilekçe Bekleniyor': 'Sigorta Başvuru',
    'Yeni Sigorta Başvuru Dilekçe Bekleniyor': 'Yeni Sigorta Başvuru',
    'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor': 'Ekspersiz Sigorta Başvuru',
    'Düzeltme Bekleniyor': 'Düzeltilmesi Gerekenler',
    'Müşteri Vazgeçti': 'Müşteri Hizmetleri',
    'Müvekkil Reddedildi': 'Hukuk Departmanı',
    'Çağrı Formu Onaylandı': 'Onaylı Çağrı Formu',
    'Çağrı Formu Reddedildi': 'Red Nedenleri',
    'Tüm Form': 'Üst Düzey Yönetici',
};

const getCallFormEmployee = (callFormState) => {
    return callFormStateMappings[callFormState] || 'Bilinmeyen Durum';
};

const CommentsComponent = ({ formData, errors, handleInputChange, callFormState, existingComments = [], setExistingComments, canEdit = true }) => {
    const callFormEmployee = getCallFormEmployee(callFormState);
    const [allComments, setAllComments] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [editedComment, setEditedComment] = useState('');
    const [userFullName, setUserFullName] = useState('');
    
    // Check if there's already a comment for the current state
    const currentStateCommentIndex = allComments.findIndex(
        comment => comment.commentType.startsWith(callFormEmployee)
    );
    
    // Initialize comments from existing data if available or use defaults
    useEffect(() => {
        // Get user full name from localStorage
        const storedUserName = localStorage.getItem('userFullName');
        setUserFullName(storedUserName || 'Kullanıcı');
        
        // If existingComments is provided, use those
        if (existingComments && existingComments.length > 0) {
            setAllComments(existingComments);
        } 
        // If formData has comments property and it's an array, use that
        else if (formData.comments && Array.isArray(formData.comments)) {
            setAllComments(formData.comments);
        }
        // Otherwise, use an empty array
        else {
            setAllComments([]);
        }
    }, [existingComments, formData.comments]);

    // Start editing a comment
    const handleEditComment = (index) => {
        setEditingIndex(index);
        setEditedComment(allComments[index].comment);
    };

    // Save edited comment
    const handleSaveComment = (index) => {
        // Only update if there's content
        if (editedComment.trim()) {
            // Create updated comments array
            const updatedComments = [...allComments];
            
            // Orijinal commentType'dan department kısmını al (kullanıcı adı varsa çıkar)
            const originalCommentType = updatedComments[index].commentType;
            const departmentPart = originalCommentType.includes(' - ') 
                ? originalCommentType.split(' - ')[0] 
                : originalCommentType;
            
            // Yeni commentType'ı kullanıcı adıyla birlikte oluştur
            const newCommentType = `${departmentPart} - ${userFullName}`;
            
            updatedComments[index] = {
                ...updatedComments[index],
                commentType: newCommentType,
                comment: editedComment.trim()
            };
            
            // Update local state
            setAllComments(updatedComments);
            
            // Update parent component state if setExistingComments prop exists
            if (setExistingComments) {
                setExistingComments(updatedComments);
            }
            
            // Reset editing state
            setEditingIndex(-1);
            setEditedComment('');
        }
    };

    // Cancel editing
    const handleCancelEdit = () => {
        setEditingIndex(-1);
        setEditedComment('');
    };

    // Delete a comment
    const handleDeleteComment = (index) => {
        // Sadece mevcut state'e ait yorumları silebilmelidir
        const commentType = allComments[index].commentType;
        if (!commentType.startsWith(callFormEmployee) && callFormState !== 'Tüm Form') {
            alert('Sadece mevcut duruma ait yorumları silebilirsiniz.');
            return;
        }
        
        if (window.confirm('Bu notu silmek istediğinize emin misiniz?')) {
            const updatedComments = [...allComments];
            updatedComments.splice(index, 1);
            
            // Update local state
            setAllComments(updatedComments);
            
            // Update parent component state if setExistingComments prop exists
            if (setExistingComments) {
                setExistingComments(updatedComments);
            }
        }
    };

    // Handle current state comment input changes (when editing existing comment)
    const handleCurrentCommentChange = (e) => {
        setEditedComment(e.target.value);
    };

    // İlgili yorumun düzenlenebilir olup olmadığını kontrol et
    const canEditComment = (commentType) => {
        // If canEdit is false, no comments can be edited
        if (!canEdit) {
            return false;
        }
        return commentType.startsWith(callFormEmployee) || callFormState === 'Tüm Form';
    };

    return (
        <>
            <H5>Notlar</H5>
            <div style={{ height: "20px" }}></div>

            {/* All comments including current state */}
            {allComments.length > 0 && (
                <div className="mb-4">
                    {allComments.map((comment, index) => {
                        const isEditable = canEditComment(comment.commentType);
                        
                        return (
                            <div key={index} className="mb-4">
                                <Label className="font-weight-bold">
                                    {comment.commentType}
                                    {editingIndex === index && (
                                        <span className="text-muted ms-2 font-weight-normal"> Şu anda düzenliyor: {userFullName}</span>
                                    )}
                                </Label>
                                
                                {editingIndex === index ? (
                                    <div>
                                        <Input
                                            type="textarea"
                                            value={editedComment}
                                            onChange={handleCurrentCommentChange}
                                            rows={3}
                                            className="mb-2"
                                        />
                                        <div className="d-flex">
                                            <Button
                                                color="success"
                                                size="sm"
                                                className="me-2"
                                                onClick={() => handleSaveComment(index)}
                                            >
                                                Kaydet
                                            </Button>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                className="me-2"
                                                onClick={() => handleDeleteComment(index)}
                                            >
                                                Sil
                                            </Button>
                                            <Button
                                                color="secondary"
                                                size="sm"
                                                onClick={handleCancelEdit}
                                            >
                                                İptal
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <p className="mb-2">{comment.comment}</p>
                                        {/* Sadece mevcut state'in yorumlarını düzenlenebilir yap */}
                                        {isEditable && (
                                            <div>
                                                <Button
                                                    color="warning"
                                                    size="sm"
                                                    className="me-3"
                                                    onClick={() => handleEditComment(index)}
                                                >
                                                    Düzenle
                                                </Button>
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => handleDeleteComment(index)}
                                                >
                                                    Sil
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Input for new comment when there's no existing one for current state */}
            {currentStateCommentIndex === -1 && (
                <FormGroup>
                    <Label for="notes">
                        {callFormEmployee} - {userFullName}
                    </Label>
                    <Input
                        type="textarea"
                        id="notes"
                        name="notes"
                        value={formData.notes || ''}
                        onChange={handleInputChange}
                        invalid={!!errors.notes}
                        rows={4}
                        disabled={!canEdit}
                    />
                    <FormFeedback>{errors.notes}</FormFeedback>
                </FormGroup>
            )}
        </>
    );
};

export default CommentsComponent;
